import { Api } from '@/store/api';
import { globalRegions, Question } from 'altru-types';

async function getQuestion({ questionId, region }: { questionId: string; region: globalRegions }): Promise<Question> {
  const response = await Api.get(`/api/${region}/questions/${questionId}`);
  return response.data.data;
}

export default getQuestion;
